import type { FaireProductEntity } from "../../entity_types/product";

export const p_hztxdnrydr: FaireProductEntity = {
  token: "p_hztxdnrydr",
  type: "product",
  name: "Perfume Mist de Guava",
  brandToken: "b_4240zqg5kc",
  brandName: "Ceremonia",
  imageUrl:
    "https://cdn.faire.com/fastly/34d7d914fb168b4d97da51bb93696633c3a49b1aa6b6fe346493b1db2d92cd60.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 24,
  description: "Perfume Mist de Guava for wholesale.",
  tags: ["fragrance"],
  caseSize: 1,
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-04-14T00:00:00.000Z",
    importedBy: "ceremonia-brand-prototype",
  },
  categoryTokens: [],
};
